import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hourFormatter'
})
export class HourFormatterPipe implements PipeTransform {

  transform(date: string): any{
    if (date) {
        let splitDate = date.split("T");
        let sDate;
        if(splitDate.length === 1){
           sDate = splitDate[0];
        }else{
           sDate = splitDate[1];
        }
        let splitHour = sDate.split(":");
        return (splitHour[0] + "h" + splitHour[1]);
    }
}
}
